import React, { useState } from "react";
import wadeIcon from "../../../components/Icons/wadeIcon.svg";
import { Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { cn } from "../../../helpers";
import { getEmailEnable2FAService } from "../../../services/emailEnable2FA.service";

const EmailVerification = () => {
  const [email, setEmail] = useState("");
  const [invalidMailId, setInvalidMailId] = useState(false);
  const [incorrectEmailInputChange, setIncorrectEmailInputChange] =
    useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const validateEmail = () => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  };

  const onInputChange = (e: any) => {
    if (e.target.name === "email" && invalidMailId) {
      setIncorrectEmailInputChange(true);
    }
    setEmail(e.target.value);
  };

  const onGetCodeButtonClickHandler = () => {
    setIncorrectEmailInputChange(false);
    if (validateEmail()) {
      getEmailEnable2FAService(
        location.state.email,
        location.state.password,
        location.state.user_id
      );
      navigate("/codeVerification", {
        state: {
          email: email,
          password: location.state.password,
          verifyType: "email",
          user_id: location.state.user_id,
        },
      });
    } else {
      setInvalidMailId(true);
    }
  };

  return (
    <div className="tw-min-h-screen tw-bg-gray-100 tw-flex tw-justify-center tw-items-center tw-p-4">
      <div className="tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden tw-flex tw-flex-col tw-relative tw-w-full tw-max-w-xl">
        {/* Top Accent Line */}
        <div className="tw-h-2 tw-bg-gradient-to-r tw-from-[#03234a] tw-to-[#04346c] tw-w-full"></div>

        <div className="tw-p-6 md:tw-p-10 tw-flex tw-flex-col tw-items-center">
          {/* Logo */}
          <div className="tw-mb-8 tw-bg-gray-50 tw-p-4 tw-rounded-full tw-shadow-sm">
            <img src={wadeIcon} alt="WADE Logo" className="tw-h-8" />
          </div>

          {/* Title */}
          <h2 className="tw-text-[#03234a] tw-text-2xl tw-font-bold tw-mb-2 tw-text-center">
            Email Verification
          </h2>

          {/* Description */}
          <p className="tw-text-gray-500 tw-text-center tw-mb-8 tw-text-sm md:tw-text-base tw-leading-relaxed tw-max-w-sm">
            Enter the email address you'd like to receive the verification code.
          </p>

          {/* Form Content */}
          <div className="tw-w-full tw-max-w-sm tw-mb-8">
            <div className="tw-mb-4">
              <label className="tw-block tw-text-sm tw-font-bold tw-text-[#03234a] tw-mb-2">
                Email
              </label>
              <input
                type="email"
                placeholder="Enter Email ID"
                value={email}
                onChange={onInputChange}
                name="email"
                maxLength={100}
                className={cn(
                  "tw-w-full tw-px-4 tw-py-3 tw-rounded-xl tw-border-2 tw-bg-gray-50 tw-outline-none tw-transition-all",
                  invalidMailId || incorrectEmailInputChange
                    ? "tw-border-red-300 focus:tw-border-red-500 tw-text-red-900 placeholder:tw-text-red-300"
                    : "tw-border-gray-200 focus:tw-border-[#03234a]"
                )}
              />
              {invalidMailId && (
                <p className="tw-mt-2 tw-text-sm tw-text-red-600 tw-font-medium">
                  Invalid Email. Please try again.
                </p>
              )}
            </div>
          </div>

          {/* Action Button */}
          <Button
            className="tw-w-full tw-max-w-sm tw-h-12 tw-bg-[#03234a] tw-text-white tw-font-bold tw-tracking-wide tw-rounded-xl hover:tw-bg-[#052d5e] focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-[#03234a] disabled:tw-opacity-50 disabled:tw-cursor-not-allowed tw-transition-all tw-shadow-lg hover:tw-shadow-xl hover:-tw-translate-y-0.5 active:tw-translate-y-0"
            onClick={onGetCodeButtonClickHandler}
            disabled={email === ""}
          >
            Send
          </Button>
        </div>
      </div>
    </div>
  );
};
export default EmailVerification;
